/**
 * CHG-052: 프로젝트 이슈 타입 설정 React Query 훅
 */
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as configApi from '../services/projectIssueTypeConfigService';
import { projectIssueTypeKeys } from './useProjectIssueTypes';

export const configKeys = {
  config: (projectId: string) => ['project-issue-type-config', projectId] as const,
};

export function useProjectIssueTypeConfig(projectId: string) {
  return useQuery({
    queryKey: configKeys.config(projectId),
    queryFn: () => configApi.fetchProjectIssueTypeConfig(projectId),
    enabled: !!projectId,
  });
}

export function useChangeProjectScheme() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (params: { projectId: string; schemeId: string }) =>
      configApi.changeProjectScheme(params.projectId, params.schemeId),
    onSuccess: (_, vars) => {
      qc.invalidateQueries({ queryKey: configKeys.config(vars.projectId) });
      qc.invalidateQueries({ queryKey: projectIssueTypeKeys.all(vars.projectId) });
    },
  });
}

export function useAddOverride() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (params: { projectId: string; issueTypeId: string; action: 'ADD' | 'REMOVE' }) =>
      configApi.addOverride(params.projectId, params.issueTypeId, params.action),
    onSuccess: (_, vars) => {
      qc.invalidateQueries({ queryKey: configKeys.config(vars.projectId) });
      qc.invalidateQueries({ queryKey: projectIssueTypeKeys.all(vars.projectId) });
    },
  });
}

export function useRemoveOverride() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (params: { projectId: string; issueTypeId: string }) =>
      configApi.removeOverride(params.projectId, params.issueTypeId),
    onSuccess: (_, vars) => {
      qc.invalidateQueries({ queryKey: configKeys.config(vars.projectId) });
      qc.invalidateQueries({ queryKey: projectIssueTypeKeys.all(vars.projectId) });
    },
  });
}

export function useMigrationPreview() {
  return useMutation({
    mutationFn: (params: { projectId: string; opts: { newSchemeId?: string; removeTypeIds?: string[] } }) =>
      configApi.migrationPreview(params.projectId, params.opts),
  });
}
